<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-10-11 12:27:32
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-15 18:00:05
-->
<template>
  <div class="tag-container">
    <div
      :class="['tag bsizing', isDelete ? 'delete-tag' : '', 'overfl-oneline']"
      :style="{
        background: color,
        borderRadius: radius + 'px'
      }"
    >
      <span class="tag-text overfl-oneline">
        <slot></slot>
      </span>
      <div v-if="isDelete" class="delete-icon" @click.stop="handleDelete">
        <svg-icon class="icon translate-c" name="icon-close" />
      </div>
    </div>
    <div
      v-if="tagLength && tagLength !== 1"
      class="tag-num flex-v-c"
      :style="{
        background: color,
        borderRadius: radius + 'px'
      }"
    >
      {{ tagLength }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    color: {
      type: String,
      default: '#E1E8FA'
    },
    tagLength: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      default: 32
    },
    isDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete'],
  methods: {
    handleDelete() {
      this.$emit('delete')
    }
  }
})
</script>

<style lang="less">
.tag-container {
  display: flex;
  // height: 20px;
  width: 100%;
  white-space: nowrap;
  margin-right: 10px;

  &:last-of-type {
    margin-right: 0;
  }

  .tag {
    display: inline-block;
    padding: 0 8px;
    max-width: 100%;
    height: 20px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.75);
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;

    &.delete-tag {
      padding-right: 4px;
    }

    .delete-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      background: rgba(0, 0, 0, 0.65);
      border-radius: 100%;
      margin-left: 9px;
      vertical-align: -2px;
      position: relative;
      cursor: pointer;

      .icon {
        width: 10px;
        height: 10px;
        color: #fff;
      }
    }
  }

  .tag-num {
    display: inline-block;
    color: rgba(0, 0, 0, 0.75);
    font-size: 12px;
    font-weight: 400;
    padding: 0 6px;
    height: 20px;
    line-height: 20px;
    margin-left: 6px;
    min-width: 23px;
    text-align: center;
  }
}
</style>
